var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.iconComponentName,{tag:"component",attrs:{"icon-id":_vm.iconId,"direction":_vm.direction,"size":_vm.size,"variant":_vm.variant,"fill":_vm.fill},nativeOn:{"click":function($event){return ((e) => _setup.emit('click', e)).apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }